import { WebsocketChannel } from '~/enums/websocket-channel'
import { WebsocketEvent } from '~/enums/websocket-event'
import { useLiveGamesStore } from '~/store/useLiveGamesStore'
import { useLogger } from '~/composables/useLogger'
import type { WebsocketMessage } from '~/types/models/websocket-message'
import { WebsocketFeedType } from '~/enums/websocket-feed-type'

export default defineNuxtPlugin(() => {
  const logger = useLogger('websockets')

  logger.info('Websockets client plugin loaded')

  const echo = useEcho()
  const { processMessage, addBoxScoreFromMessage, updateStatisticsFromMessage } = useLiveGamesStore()

  echo
    .channel(WebsocketChannel.PushFeed)
    .listen(WebsocketEvent.MessageReceived, (message: WebsocketMessage.Model) => {
      const data: WebsocketMessage.Model = useKeysToCamelCase(message)
      switch (data.feedType) {
        case WebsocketFeedType.EVENTS:
          processMessage(data as WebsocketMessage.EventMessage)
          break
        case WebsocketFeedType.BOXSCORE:
          addBoxScoreFromMessage(data as WebsocketMessage.BoxScoreMessage)
          break
        case WebsocketFeedType.STATISTICS:
          updateStatisticsFromMessage(data.message as WebsocketMessage.StatisticsMessage)
          break
      }
    })
    .error((e: unknown) => {
      logger.error('websockets error', e)
    })
})
